import React, { Component } from 'react'

import Header from '../header/Header'
import { toast } from 'react-toastify'
import api from '../../utils/api'
import { validNumberRegex } from '../../utils/validations'
import DatePicker from 'react-datepicker'
import { getYear, validemailIdRegex } from '../../utils/validations'
import { Typeahead } from 'react-bootstrap-typeahead'

import Attach from '../../utils/images/attach.svg'
import Trash from '../../utils/images/trash.svg'

export default class WorkStatusForm extends Component {
  constructor(props) {
    super(props)

    const { history } = this.props

    if (this.props.location.state) {
      this.state = {
        ...this.props.location.state,
        isUpdateRequest: true,
        districtOption: [],
        vidhanSabhaOption: [],
        panchayatOption: [],
        isDisabled: false,
        nextStep: false,
        selectedFile: null,
        errors: {
          applicantName: '',
          mobileNumber: '',
          district: '',
          panchayat: '',
          vidhanSabha: '',
          applicationDate: '',
          applicantFrom: '',
          applicantName: '',
          typeOfWork: '',
          workDone: '',
        },
      }
    } else {
      this.state = {
        mobileNumber: '',
        whatsappNumber: '',
        district: '',
        panchayat: '',
        vidhanSabha: '',
        remarks: '',
        followUp1: '',
        followUp2: '',
        isUpdateRequest: false,
        districtOption: [],
        vidhanSabhaOption: [],
        panchayatOption: [],
        isDisabled: false,
        village: '',
        block: '',
        address: '',
        emailId: '',
        nextStep: false,
        applicationDate: '',
        typeOfWork: 'Other',
        remarkByHMP: '',
        companyName: '',
        dateOfAppointment: '',
        selectedfile: null,
        monthlySalary: '',
        otherRemarks: '',
        workDoneBy: '',
        workDone: 'No',
        fileUrl: null,
        applicantFrom: 'constituency',
        selectedFilesFormData: new FormData(),
        errors: {
          applicantName: '',
          mobileNumber: '',
          district: '',
          panchayat: '',
          vidhanSabha: '',
          applicationDate: '',
          applicantFrom: '',
          applicantName: '',
          typeOfWork: '',
          workDone: '',
        },
      }
    }
    this.fileInputRef = React.createRef()
    this.toastID = React.createRef(null)
  }

  handleChange = (event) => {
    event.preventDefault()
    const { name, value } = event.target
    let errors = this.state.errors

    switch (name) {
      case 'applicantName':
        errors.applicantName = value.length === 0 ? 'This is a required field.' : ''
        break
      case 'applicationDate':
        errors.applicationDate = value.length === 0 ? 'This is a required field.' : ''
        break
      case 'district':
        errors.district = value.length === 0 ? 'This is a required field.' : ''
        break
      case 'panchayat':
        errors.panchayat = value.length === 0 ? 'This is a required field.' : ''
        break
      case 'vidhanSabha':
        errors.vidhanSabha =
          value.length === 0 ? 'This is a required field.' : ''
        break

        case 'typeOfWork':
        errors.typeOfWork =
          value.length === 0 ? 'This is a required field.' : ''
        break
        case 'workDone':
        errors.workDone =
          value.length === 0 ? 'This is a required field.' : ''
        break
      
      case 'mobileNumber':
        errors.mobileNumber =
          value.length === 0 ? 'This is a required field.' : ''
        break
      default:
        break
    }

    this.setState({ errors })
  }

  componentDidMount = () => {
    this.fetchConstituency()
    if (this.state.isUpdateRequest) {
      this.makeVidhanSabha()
      this.makePanchayat()
    }
  }

  fetchConstituency = async () => {
    await api
      .getConstituency({
        type: 'Zila Level',
        limit: '10000',
        offset: '0',
      })
      .then((response) => {
        if (response.data.error) {
          toast.error('No Disrict found. Please make Disrict first.', {
            autoClose: 1250,
            closeButton: false,
          })
        } else {
          toast.success('District Fetched sucessfully.', {
            autoClose: 1250,
            closeButton: false,
          })
          localStorage.setItem(
            'District',
            JSON.stringify(response.data.data.rows)
          )
          this.makeDistrict()
        }
      })
    await api
      .getConstituency({
        type: 'Vidhan Sabha',
        limit: '10000',
        offset: '0',
      })
      .then((response) => {
        if (response.data.error) {
          toast.error(
            'No Vidhan Sabha found. Please make Vidhan Sabha first.',
            {
              autoClose: 1250,
              closeButton: false,
            }
          )
        } else {
          toast.success('Vidhan Sabha Fetched sucessfully.', {
            autoClose: 1250,
            closeButton: false,
          })
          localStorage.setItem(
            'Vidhan Sabha',
            JSON.stringify(response.data.data.rows)
          )
        }
      })
    await api
      .getConstituency({
        type: 'Gram Panchayat',
        limit: '10000',
        offset: '0',
      })
      .then((response) => {
        if (response.data.error) {
          toast.error('No Panchayat found. Please make Panchayat first.', {
            autoClose: 1250,
            closeButton: false,
          })
        } else {
          toast.success('Panchayat Fetched sucessfully.', {
            autoClose: 1250,
            closeButton: false,
          })
          localStorage.setItem(
            'Panchayat',
            JSON.stringify(response.data.data.rows)
          )
        }
      })
  }

  makeDistrict = () => {
    const district = JSON.parse(localStorage.getItem('District'))
    let temp = []
    district.map((data) => {
      temp.push(data.meta.name)
    })
    this.setState({
      districtOption: [...temp],
    })
  }

  makeVidhanSabha = () => {
    const vidhanSabha = JSON.parse(localStorage.getItem('Vidhan Sabha'))
    let temp = []
    vidhanSabha.map((data) => {
      if (data.meta.district === this.state.district) {
        temp.push(data.meta.name)
      }
    })
    if (temp.length === 0) {
      toast.error(
        'No Vidhan Sabha for this district. Please make Vidhan sabha.',
        {
          autoClose: 1500,
          closeButton: false,
        }
      )
    } else {
      this.setState({
        vidhanSabhaOption: [...temp],
      })
    }
  }

  makePanchayat = () => {
    const Panchayat = JSON.parse(localStorage.getItem('Panchayat'))
    let temp = []
    Panchayat.map((data) => {
      if (data.meta.vidhanSabha === this.state.vidhanSabha) {
        temp.push(data.meta.name)
      }
    })
    if (temp.length === 0) {
      toast.error(
        'No Panchayat for this vidhan sabha. Please make Panchayat.',
        {
          autoClose: 1500,
          closeButton: false,
        }
      )
    } else {
      this.setState({
        panchayatOption: [...temp],
      })
    }
  }

  handleUploadFile = async () => {

    let toastID = this.toastID

    const data = new FormData()

    data.append('file', this.state.selectedFile)

    try {
       const res = await api.uploadFile({ selectedPhotos: data, toastID })
       
       if(res?.data && res?.data.status) {
         return res.data.data
       } else {
        toast.error('File upload failed. Please try again.', {
          autoClose: 1250,
          closeButton: false,
        })
        return false
       }

    } catch (error) {

      return false

    }
  }

  handleSubmit = async () => {

    let file = ''

    if(this.state.selectedFile) {
      file = await this.handleUploadFile()
    }

    let body = {
      applicantName: this.state.applicantName,
      applicationDate: this.state.applicationDate,
      applicantFrom: this.state.applicantFrom,
      district: this.state.district,
      vidhanSabha: this.state.vidhanSabha,
      panchayat: this.state.panchayat,
      mobileNumber: this.state.mobileNumber,
      whatsappNumber: this.state.whatsappNumber,
      emailId: this.state.emailId,
      typeOfWork: this.state.typeOfWork,
      remarkByHMP: this.state.remarkByHMP,
      companyName: this.state.companyName,
      otherRemarks: this.state.otherRemarks,
      workDoneBy: this.state.workDoneBy,
      workDone: this.state.workDone,
      followUp1: this.state.followUp1,
      followUp2: this.state.followUp2,
      fileUrl: file ? file : '',
      remarks: this.state.remarks,
      companyName: this.state.companyName,
    }

    if(this.state.village && this.state.village !== '') {
      body = { ...body, village: this.state.village }
    }

    if(this.state.block && this.state.block !== '') {
      body = { ...body, block: this.state.block }
    }

    if(this.state.address && this.state.address !== '') {
      body = { ...body, address: this.state.address }
    }

    if(this.state.dateOfAppointment && this.state.dateOfAppointment !== '') {
      body = { ...body, dateOfAppointment: this.state.dateOfAppointment }
    }

    if(this.state.monthlySalary && this.state.monthlySalary !== '') {
      body = { ...body, monthlySalary: this.state.monthlySalary }

    }

    try {
      const res = await api.postWorkData(
        {
          ...body
        }
      )
      
      if(res?.data && res?.data.status) {
        toast.success('Work done record created successfully', {
          autoClose: 1250,
          closeButton: false,
        })

        this.props.history.push('/manage-work-status')

      } else {
        toast.error('Work done record creation failed. Please try again.', {
          autoClose: 1250,
          closeButton: false,
        })
        this.setState({ isDisabled: false })
      }

    } catch (error) {
      debugger
    }

    
  }

  handleUpdate = async () => {
    try {

      let file = ''

      if(this.state.selectedFile) {
        file = await this.handleUploadFile()
      } else if( this.state.fileUrl) {
        file = this.state.fileUrl
      }

      let body = {
        id: this.state.id,
        applicantName: this.state.applicantName,
        applicationDate: this.state.applicationDate,
        applicantFrom: this.state.applicantFrom,
        district: this.state.district,
        vidhanSabha: this.state.vidhanSabha,
        panchayat: this.state.panchayat,
        state: this.state.state,
        mobileNumber: this.state.mobileNumber,
        whatsappNumber: this.state.whatsappNumber,
        emailId: this.state.emailId,
        typeOfWork: this.state.typeOfWork,
        remarkByHMP: this.state.remarkByHMP,
        companyName: this.state.companyName,
        otherRemarks: this.state.otherRemarks,
        workDoneBy: this.state.workDoneBy,
        workDone: this.state.workDone,
        followUp1: this.state.followUp1,
        followUp2: this.state.followUp2,
        fileUrl: file,
        remarks: this.state.remarks,
        companyName: this.state.companyName,
      }

      if(this?.state?.village && this?.state?.village !== '' && this?.state?.village !== null) {
        body = { ...body, village: this.state.village }
      }

      if(this?.state?.block && this?.state?.block !== '' && this?.state?.block !== null) {
        body = { ...body, block: this.state.block }
      }

      if(this?.state?.address && this?.state?.address !== '' && this?.state?.address !== null) {
        body = { ...body, address: this.state.address }
      }

      if(this?.state?.dateOfAppointment && this?.state?.dateOfAppointment !== '' && this?.state?.dateOfAppointment !== null) {
        body = { ...body, dateOfAppointment: this.state.dateOfAppointment }
      }

      if(this?.state?.monthlySalary && this?.state?.monthlySalary !== '' && this?.state?.monthlySalary !== null) {
        body = { ...body, monthlySalary: this.state.monthlySalary }
      }

      const res = await api.updateWorkData({...body})

      if(res?.data && res?.data.status) {
        toast.success('Work done record updated successfully', {
          autoClose: 1250,
          closeButton: false,
        })

        this.props.history.push('/manage-work-status')

      } else {
        toast.error('Work done record updation failed. Please try again.', {
          autoClose: 1250,
          closeButton: false,
        })
        this.setState({ isDisabled: false })
      }
      
    } catch (error) {
      debugger
    }
  }

  makeLetterCapital = (event) => {
    
    let { district, vidhanSabha, panchayat } = { ...this.state }
    if (district.charAt(0) !== district.charAt(0).toUpperCase()) {
      district = district.charAt(0).toUpperCase() + district.slice(1)
    }

    if (vidhanSabha.charAt(0) !== vidhanSabha.charAt(0).toUpperCase()) {
      vidhanSabha = vidhanSabha.charAt(0).toUpperCase() + vidhanSabha.slice(1)
    }
    if (panchayat.charAt(0) !== panchayat.charAt(0).toUpperCase()) {
      panchayat = panchayat.charAt(0).toUpperCase() + panchayat.slice(1)
    }

    this.setState(
      {
        district: district,
        vidhanSabha: vidhanSabha,
        panchayat: panchayat,
        isDisabled: true,
      },
      () => {
        
        if (this.state.isUpdateRequest) {
          this.handleUpdate()
        } else {
          this.handleSubmit()
        }
      }
    )
  }

  onFileChange = (event) => {
    const file = event.target.files[0] // Only first file
    if (!file) return
  
    const allowedExtensions = ['.pdf', '.png', '.jpg', '.jpeg']
    const fileName = file.name.toLowerCase()
    const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext))
  
    if (!isValidExtension) {
      toast.error('File should be PDF/JPG/JPEG/PNG format', { autoClose: 1250, closeButton: false })
      event.target.value = ''
      return
    }
  
    if (file.size > 2 * 1024 * 1024) { // 2 MB
      toast.error('File size should be less than 2MB', { autoClose: 1250, closeButton: false })
      event.target.value = ''
      return
    }    

    this.setState({ selectedFile: file }) // Store only one file

    event.target.value = ''
    }

    

  render() {
    const { isUpdateRequest } = this.state

    return (
      <div className="NewClientForm">
        <Header />
        <div className="frame">
          <div className="FormOuterFrame">
            <div className="DivHeading">
              <p className="TxtHeading">Work Status</p>
            </div>
            <div className="FormFrame">
              <form onSubmit={(e) => {
                e.preventDefault()
                if(this.state.nextStep) {
                  
                  this.makeLetterCapital()
                } else {
                  this.setState({ nextStep: true })
                }
              }}>

                {
                  this.state.nextStep ? <>

                <div className="TxtInputFrame">
                  <p className="TxtInput">Remarks by HMP</p>
                  
                </div>
                <textarea
                  type="text"
                  id="remarkByHMP"
                  name="remarkByHMP"
                  className="InputFrame"
                  placeholder="Enter Reamarks. Max 500 characters."
                  rows="10"
                  maxLength="500"
                  value={this.state.remarkByHMP}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ remarkByHMP: e.target.value })
                  }}
                />


                

                <div className="TxtInputFrame">
                  <p className="TxtInput">Type of Work</p>
                  <p className="TxtStar">*</p>
                </div>
                <div style={{ marginBottom: '30px' }}>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() => this.setState({ typeOfWork: 'Transfer' })}
                    >
                      <span
                        className={
                          this.state.typeOfWork === 'Transfer'
                            ? 'checked'
                            : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">Transfer</p>
                  </div>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() => this.setState({ typeOfWork: 'Jobs' })}
                    >
                      <span
                        className={
                          this.state.typeOfWork === 'Jobs'
                            ? 'checked'
                            : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">Job</p>
                  </div>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() => this.setState({ typeOfWork: 'Request' })}
                    >
                      <span
                        className={
                          this.state.typeOfWork === 'Request'
                            ? 'checked'
                            : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">Request</p>
                  </div>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() => this.setState({ typeOfWork: 'Posting' })}
                    >
                      <span
                        className={
                          this.state.typeOfWork === 'Posting'
                            ? 'checked'
                            : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">Posting</p>
                  </div>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() => this.setState({ typeOfWork: 'Hospital' })}
                    >
                      <span
                        className={
                          this.state.typeOfWork === 'Hospital'
                            ? 'checked'
                            : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">Hospital</p>
                  </div>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() => this.setState({ typeOfWork: 'Other' })}
                    >
                      <span
                        className={
                          this.state.typeOfWork === 'Other'
                            ? 'checked'
                            : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">Other</p>
                  </div>
                </div>
                <span className="validation-error-message">
                  {this.state.errors.typeOfWork}
                </span>


                <div className="TxtInputFrame">
                  <p className="TxtInput">Work Done</p>
                  <p className="TxtStar">*</p>
                </div>
                <div style={{ marginBottom: '30px' }}>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() => this.setState({ workDone: 'Yes' })}
                    >
                      <span
                        className={
                          this.state.workDone === 'Yes'
                            ? 'checked'
                            : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">Yes</p>
                  </div>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() => this.setState({ workDone: 'No' })}
                    >
                      <span
                        className={
                          this.state.workDone === 'No'
                            ? 'checked'
                            : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">No</p>
                  </div>
                 
                </div>

                <div className="TxtInputFrame">
                  <p className="TxtInput">Company/Organization with whom shared</p>
                </div>

                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  className="InputFrame"
                  placeholder="Please enter company/organization name"
                  value={this.state.companyName}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ companyName: e.target.value })
                  }}
                />

<div className="TxtInputFrame">
                  <p className="TxtInput">Date of Apppointment</p>
                  
                </div>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  placeholder="Pick from calendar view"
                  className="InputFrame"
                  selected={
                    this?.state?.dateOfAppointment !== '' && this?.state?.dateOfAppointment !== null
                      ? new Date(this.state.dateOfAppointment)
                      : ''
                  }
                  onChange={(date) => {
                    this.setState({ dateOfAppointment: date })
                  }}
                  
                />

<div className="TxtInputFrame">
                <p className="TxtInput">Monthly Salary</p>
               
              </div>

              <input
                type="number"
                id="monthlySalary"
                name="monthlySalary"
                className="InputFrame"
                placeholder="Please enter monthly salary"
                value={this.state.monthlySalary}
                onChange={(e) => {
                  this.handleChange(e)
                  this.setState({ monthlySalary: e.target.value })
                }}
              />

<div className="TxtInputFrame">
                  <p className="TxtInput">Remarks</p>
                 
                </div>
                <textarea
                  type="text"
                  id="otherRemarks"
                  name="otherRemarks"
                  className="InputFrame"
                  placeholder="Enter Remarks. Max 500 characters."
                  rows="10"
                  maxLength="500"
                  value={this.state.otherRemarks}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ otherRemarks: e.target.value })
                  }}
                />

<div className="TxtInputFrame">
                    <p className="TxtInput">
                      Attachment (Max File Size 2MB &amp; JGP, JPEG, PNG &amp; PDF format
                      only)
                    </p>
                  </div>
                  
                  {
                    this.state.selectedFile ? <div className="SelectedItemFrame" >
                    <img
                      src={Trash}
                      alt=""
                      className="AttachFile"
                      onClick={() => {
                       
                        this.setState({ selectedFile: null })
                      }}
                    />
                    <p className="TxtBrowse">{this.state.selectedFile.name}</p>
                  </div> : this.state.fileUrl ? <div className="SelectedItemFrame" >
                          <img
                            src={Trash}
                            alt=""
                            className="AttachFile"
                            onClick={() => {
                              
                              this.setState({ selectedfile: null, fileUrl: null })
                            }}
                          />
                          <p className="TxtBrowse">{this.state.fileUrl}</p>
                        </div> : null
                  }
                  <input
                    type="file"
                    
                    onChange={this.onFileChange}
                    ref={this.fileInputRef}
                    className="FileInput"
                    accept="application/pdf, image/png, image/jpeg, image/jpg"
                  />
                  <div
                    className="SelectFile"
                    onClick={() => this.fileInputRef.current.click()}
                  >
                    <img
                      src={Attach}
                      alt=""
                      className="AttachFile non-printable"
                    />
                    <p className="TxtBrowse">Browse Files</p>
                  </div>
                
                
             

             


                    <div className="TxtInputFrame">
                  <p className="TxtInput">Follow up 1</p>
                  
                </div>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  placeholder="Pick from calendar view"
                  className="InputFrame"
                  selected={
                    this.state.followUp1 !== ''
                      ? new Date(this.state.followUp1)
                      : ''
                  }
                  onChange={(date) => {
                    let errors = this.state.errors
                    if (getYear(date).toString().length === 4) {
                      errors.followUp1 = ''
                      this.setState({ followUp1: date, errors })
                    } else {
                      errors.followUp1 = 'Invalid Year'
                      this.setState({ errors })
                    }
                  }}
                />

               

                <div className="TxtInputFrame">
                  <p className="TxtInput">Follow up 2</p>
                  
                </div>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  placeholder="Pick from calendar view"
                  className="InputFrame"
                  selected={
                    this.state.followUp2 !== ''
                      ? new Date(this.state.followUp2)
                      : ''
                  }
                  onChange={(date) => {
                    let errors = this.state.errors
                    if (getYear(date).toString().length === 4) {
                      errors.followUp2 = ''
                      this.setState({ followUp2: date, errors })
                    } else {
                      errors.followUp1 = 'Invalid Year'
                      this.setState({ errors })
                    }
                  }}
                />

               

                <div className="TxtInputFrame">
                  <p className="TxtInput">Work Done by</p>
                  
                </div>

                <input
                  type="text"
                  id="workDoneBy"
                  name="workDoneBy"
                  className="InputFrame"
                  placeholder="Please enter work done by"
                 
                  value={this.state.workDoneBy}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ workDoneBy: e.target.value })
                  }}
                />
                

                  </> : <>
                  <div className="TxtInputFrame">
                  <p className="TxtInput">Applicant From</p>
                  <p className="TxtStar">*</p>
                </div>
                <div style={{ marginBottom: '30px' }}>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() =>
                        this.setState({
                          applicantFrom: 'constituency',
                          state: '',
                          district: '',
                          vidhanSabha: '',
                          panchayat: '',
                        })
                      }
                    >
                      <span
                        className={
                          this.state.applicantFrom === 'constituency'
                            ? 'checked'
                            : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">Constituency</p>
                  </div>
                  <div className="SelectRadio">
                    <label
                      className="radiobutton"
                      onClick={() =>
                        this.setState({
                          applicantFrom: 'other',
                          district: '',
                          panchayat: '',
                          vidhanSabha: '',
                        })
                      }
                    >
                      <span
                        className={
                          this.state.applicantFrom === 'other' ? 'checked' : 'unchecked'
                        }
                      />
                    </label>
                    <p className="TxtRadioInput">Other</p>
                  </div>
                </div>

              <div className="TxtInputFrame">
                  <p className="TxtInput">Applicant Name</p>
                  <p className="TxtStar">*</p>
                </div>

                <input
                  type="text"
                  id="applicantName"
                  name="applicantName"
                  className="InputFrame"
                  placeholder="Please enter applicant name"
                  required
                  value={this.state.applicantName}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ applicantName: e.target.value })
                  }}
                />
                <span className="validation-error-message">
                  {this.state.errors.applicantName}
                </span>

                <div className="TxtInputFrame">
                  <p className="TxtInput">Date</p>
                  <p className="TxtStar">*</p>
                </div>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  placeholder="Pick from calendar view"
                  className="InputFrame"
                  selected={
                    this.state.applicationDate !== ''
                      ? new Date(this.state.applicationDate)
                      : ''
                  }
                  onChange={(date) => {
                    let errors = this.state.errors
                    if (getYear(date).toString().length === 4) {
                      errors.applicationDate = ''
                      this.setState({ applicationDate: date, errors })
                    } else {
                      errors.callOnDate = 'Invalid Year'
                      this.setState({ errors })
                    }
                  }}
                />

                <span className="validation-error-message">
                  {this.state.errors.applicationDate}
                </span>

                {
                  this.state.applicantFrom === 'constituency' ?  
                  
                  <>
                    <div className="TxtInputFrame">
                  <p className="TxtInput">District</p>
                  <p className="TxtStar">*</p>
                </div>

                <Typeahead
                  id="district"
                  labelKey="district"
                  placeholder="Please select a District"
                  required
                  onChange={(district) => {
                    this.setState({ district: district[0] }, () =>
                      this.makeVidhanSabha()
                    )
                  }}
                  options={this.state.districtOption}
                  defaultInputValue={this.state.district}
                  style={{ marginBottom: '20px' }}
                />
                <span className="validation-error-message">
                  {this.state.errors.district}
                </span>

                <div className="TxtInputFrame">
                  <p className="TxtInput">Vidhan Sabha</p>
                  <p className="TxtStar">*</p>
                </div>
                <Typeahead
                  id="vidhanSabha"
                  labelKey="vidhanSabha"
                  placeholder="Please select a Vidhan Sabha"
                  onChange={(vidhanSabha) => {
                    this.setState({ vidhanSabha: vidhanSabha[0] }, () => {
                      if (vidhanSabha[0] !== '') {
                        this.makePanchayat()
                      }
                    })
                  }}
                  options={this.state.vidhanSabhaOption}
                  defaultInputValue={this.state.vidhanSabha}
                  style={{ marginBottom: '20px' }}
                />
                <span className="validation-error-message">
                  {this.state.errors.vidhanSabha}
                </span>

                <div className="TxtInputFrame">
                  <p className="TxtInput">Panchayat</p>
                  <p className="TxtStar">*</p>
                </div>
                <Typeahead
                  id="panchayat"
                  labelKey="panchayat"
                  placeholder="Please select a Panchayat"
                  required
                  onChange={(panchayat) => {
                    this.setState({ panchayat: panchayat[0] })
                  }}
                  options={this.state.panchayatOption}
                  defaultInputValue={this.state.panchayat}
                  style={{ marginBottom: '20px' }}
                />
                <span className="validation-error-message">
                  {this.state.errors.panchayat}
                </span>
                  </>
                  
                  : <>

<div className="TxtInputFrame">
                      <p className="TxtInput">District</p>
                      <p className="TxtStar">*</p>
                    </div>
                    <input
                      type="text"
                      id="district"
                      name="district"
                      className="InputFrame"
                      placeholder="Please enter district"
                      required
                      value={this.state.district}
                      onChange={(e) => {
                        this.handleChange(e)
                        this.setState({ district: e.target.value })
                      }}
                    />
                    <span className="validation-error-message">
                  {this.state.errors.district}
                </span>

<div className="TxtInputFrame">
                      <p className="TxtInput">Vidhan Sabha</p>
                      <p className="TxtStar">*</p>
                    </div>
                    <input

                      type="text"
                      id="vidhanSabha"
                      name="vidhanSabha"  
                      className="InputFrame"
                      placeholder="Please enter vidhan sabha"
                      required
                      value={this.state.vidhanSabha}
                      onChange={(e) => {
                        this.handleChange(e)
                        this.setState({ vidhanSabha: e.target.value })
                      }}
                    />
                    <span className="validation-error-message">
                  {this.state.errors.vidhanSabha}
                </span>

                    <div className="TxtInputFrame">
                      <p className="TxtInput">Panchayat</p>
                      <p className="TxtStar">*</p>
                    </div>
                    <input
                      type="text"
                      id="panchayat"
                      name="panchayat"
                      className="InputFrame"
                      placeholder="Please enter panchayat"
                      required
                      value={this.state.panchayat}
                      onChange={(e) => {
                        this.handleChange(e)
                        this.setState({ panchayat: e.target.value })
                      }}
                    />
                    <span className="validation-error-message">
                  {this.state.errors.panchayat}
                </span>

                    

                  </>
                }

                

                <div className="TxtInputFrame">
                  <p className="TxtInput">Village</p>
                 
                </div>

                <input
                  type="text"
                  id="village"
                  name="village"
                  className="InputFrame"
                  placeholder="Please enter village"
                  value={this.state.village}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ village: e.target.value })
                  }}
                />
              

                <div className="TxtInputFrame">
                  <p className="TxtInput">Block</p>
                 
                </div>

                <input
                  type="text"
                  id="block"
                  name="block"
                  className="InputFrame"
                  placeholder="Please enter block"
                  value={this.state.block}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ block: e.target.value })
                  }}
                />

<div className="TxtInputFrame">
                  <p className="TxtInput">Address</p>
                 
                </div>

                <input
                  type="text"
                  id="address"
                  name="address"
                  className="InputFrame"
                  placeholder="Please enter address"
                  value={this.state.address}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ address: e.target.value })
                  }}
                />

                <div className="TxtInputFrame">
                  <p className="TxtInput">Mobile Number</p>
                  <p className="TxtStar">*</p>
                </div>
                <input
                  type="text"
                  id="mobileNumber"
                  name="mobileNumber"
                  className="InputFrame"
                  placeholder="Please enter mobile number"
                  required
                  value={this.state.mobileNumber}
                  onChange={(e) => {
                    if (
                      (validNumberRegex.test(e.target.value) ||
                        e.target.value === '') &&
                      e.target.value.length <= 10
                    ) {
                      this.handleChange(e)
                      this.setState({ mobileNumber: e.target.value })
                    }
                  }}
                />
                <span className="validation-error-message">
                  {this.state.errors.mobileNumber}
                </span>

                <div className="TxtInputFrame">
                  <p className="TxtInput">Whatsapp Number</p>
                  
                </div>
                <input
                  type="text"
                  id="whatsappNumber"
                  name="whatsappNumber"
                  className="InputFrame"
                  placeholder="Please enter whatsapp number"
                  value={this.state.whatsappNumber}
                  onChange={(e) => {
                    if (
                      (validNumberRegex.test(e.target.value) ||
                        e.target.value === '') &&
                      e.target.value.length <= 10
                    ) {
                      this.handleChange(e)
                      this.setState({ whatsappNumber: e.target.value })
                    }
                  }}
                />
                <span className="validation-error-message">
                  {this.state.errors.whatsappNumber}
                </span>

                <div className="TxtInputFrame">
                  <p className="TxtInput">Email</p>
                </div>

                <input
                  type="emailId"
                  id="emailId"
                  name="emailId"
                  className="InputFrame"
                  placeholder="Please enter email"
                  value={this.state.emailId}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ emailId: e.target.value })
                  }}
                />

               
                <div className="TxtInputFrame">
                  <p className="TxtInput">Remarks</p>
                </div>
                <textarea
                  type="text"
                  id="remarks"
                  name="remarks"
                  className="InputFrame"
                  placeholder="Enter Remarks. Max 500 characters."
                  rows="10"
                  maxLength="500"
                  value={this.state.remarks}
                  onChange={(e) => {
                    this.handleChange(e)
                    this.setState({ remarks: e.target.value })
                  }}
                />
                  </>
                }

              

                

                

                

               

                

                {isUpdateRequest === false ? (
                  <button
                    type={"submit"}
                    className="BtnSubmit"
                    style={
                      this.state.isDisabled ? { pointerEvents: 'none' } : null
                    }
                    
                  >
                    { this.state.nextStep ? 'Submit' : 'Next Step'}
                  </button>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginBottom: '40px',
                    }}
                  >
                    <button
                      type="button"
                      className="PrintBtn UpdateButton"
                      onClick={(event) => {                       
                         event.preventDefault()
                        if( this.state.nextStep) {
                          this.setState({ isDisabled: true })
                          this.makeLetterCapital(event)
                        } else {
                          this.setState({ nextStep: true })
                        }
                       
                      }}
                      style={
                        this.state.isDisabled ? { pointerEvents: 'none' } : null
                      }
                    >
                      { this.state.nextStep ? 'Update' : 'Next Step'}
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
